export default "/images/a-thin-line-button.png?6110ed6d462a7de9b36e7178b5f7397d";